export enum AcceptedFileTypes {
  IMAGES = "IMAGES",
  DOCS = "DOCS"
}